export default __webpack_public_path__ + "static/media/eye.8d1fdc49.svg";